import React, { FunctionComponent, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import PuxNewsletterForm from 'Root/EasyRedmineGatsby/src/components/PuxNewsletterForm/PuxTrialForm'
import EasySoftwareInfoBar from 'Root/Shared/components/EasySoftwareInfoBar/EasySoftwareInfoBar'
import PuxEditorBar from 'Root/Shared/components/PuxEditor/PuxEditorBar'
import { PuxEditorProvider } from 'Root/Shared/components/PuxEditor/PuxEditorContext'
import { IPageProperties } from 'Root/Shared/utils/data/buildTypedPage'
import { initDynamicRS } from 'Root/Shared/utils/dynamicRS'
import { useEditorStatus } from 'Root/Shared/utils/edit/useEditorStatus'
import { usePreviewStatus } from 'Root/Shared/utils/edit/usePreviewStatus'
import { TurnstileSettingsContext } from 'Root/Shared/utils/turnstileContext'
import { HeaderData } from 'Shared/components/header/HeaderMobileNav'
import { localizedPathType } from 'Shared/components/PuxLanguageSelector/PuxLanguageSelector'
import { IFooterData, IHeaderData } from 'Shared/queries/layout-queries'
import { LinkType } from 'Shared/types/Link'

import Footer from './Footer'
import Header from './Header'

interface LayoutPropsType {
  customLayoutClass?: string
  style?: string
  cta?: LinkType
  landingPageNav?: HeaderData
  landingPageLogo?: string | null
  localizedPath?: localizedPathType[]
  footerData: IFooterData
  headerData: IHeaderData
  pageProperties: IPageProperties
  pageContentItemId: string
  resStrings: {
    key: string
    value: string
  }[]
}

const Layout: FunctionComponent<LayoutPropsType> = (props) => {
  const isEditor = useEditorStatus()
  const isPreview = usePreviewStatus()
  const [customHeaderClass, setCustomHeaderClass] = useState(``)
  const getHeaderCustomClass = (duplicatedNav: boolean): void => {
    setCustomHeaderClass(duplicatedNav ? `has-megamenu` : ``)
  }
  const classes = [`layout-main`, props.customLayoutClass, customHeaderClass]

  initDynamicRS(props.resStrings)

  const hasTrialBanner = !props.pageProperties?.hideTrialForm

  return (
    <PuxEditorProvider key={props.pageContentItemId}>
      <TurnstileSettingsContext.Provider value={props.headerData}>
        {!isEditor && (
          <EasySoftwareInfoBar
            background={props.pageProperties?.pagePropertiesInfoBarBackground}
            text={props.pageProperties?.pagePropertiesInfoBarText}
            path={props.localizedPath?.[0]?.path}
            resetDate={
              props.pageProperties?.pagePropertiesInfoBarResetCookieDate
            }
          />
        )}
        {(isEditor || isPreview) && (
          <PuxEditorBar
            pageContentItemId={props.pageContentItemId}
            isPreview={isPreview}
          />
        )}
        <Header
          customHeaderFnc={getHeaderCustomClass}
          customHeaderClass={props.customLayoutClass}
          style={props.style}
          cta={props.cta}
          landingPageNav={props.landingPageNav}
          landingPageLogo={props.landingPageLogo}
          localizedPaths={props.localizedPath}
          headerData={props.headerData}
        />
        <main className={classes.join(` `)}>{props.children}</main>
        <ToastContainer />
        {hasTrialBanner ? <PuxNewsletterForm /> : null}
        <Footer footerData={props.footerData} hasTrialBanner={hasTrialBanner} />
      </TurnstileSettingsContext.Provider>
    </PuxEditorProvider>
  )
}

export default Layout
